import { OptionTile } from "@manifesthhqinc/ui-library";
import { TitleLarge } from "../../../components/font";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import Container from "../../../layout/container";
import ScrollableContainer from "../../../layout/scrollable-container";
import { OptionTileContainer } from "./styles";
import { UseHenryQuestionniareProps } from "../useHenryQuestionnaire";
import HeadingContainer from "../../../layout/heading-container";

const HenryQuestionnaireTwo = (props: UseHenryQuestionniareProps) => {
  const { updateHenryQuestionnaire } = props;
  return (
    <TransitionWrapper>
      <ScrollableContainer name="henry-questionnaire-form-1">
        <Container>
          <HeadingContainer paneVariant="optionForm" withProgressBar>
            <TitleLarge>Do you currently have a retirement plan through your job — like a 401(k)?</TitleLarge>
          </HeadingContainer>
          <OptionTileContainer>
            <OptionTile
              name="yes"
              variant="clickthrough"
              appearance="secondary"
              onClick={() => updateHenryQuestionnaire({ hasCurrentEmployerSponsoredAccount: true })}
            >
              Yes
            </OptionTile>
            <OptionTile
              name="no"
              variant="clickthrough"
              appearance="secondary"
              onClick={() => updateHenryQuestionnaire({ hasCurrentEmployerSponsoredAccount: false })}
            >
              No
            </OptionTile>
          </OptionTileContainer>
        </Container>
      </ScrollableContainer>
    </TransitionWrapper>
  );
};
export default HenryQuestionnaireTwo;
